import { render, staticRenderFns } from "./InitiatedSimulationAgainstCustomer.vue?vue&type=template&id=228705bb&"
import script from "./InitiatedSimulationAgainstCustomer.vue?vue&type=script&lang=js&"
export * from "./InitiatedSimulationAgainstCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports